export const SECOND_MILLISECOND = 1000;
export const MIN_MILLISECONDS = 60000;
export const HOUR_MILLISECOND = 3600000;

export const TIMEOUT_THRESHOLD = 60000;

export const THROTTLED_SELECTOR_DELAY = 2000;
